import { useEffect, useRef, useState } from 'react';
import {
	// productModal,
	heroImage,
	home_main_mobile,
	homemain,
} from '../assets/images';
import Navbar from '../components/Navbar';
import DownArrow from '../assets/icons/downArrowIcon';
// import Pagination from '@mui/material/Pagination';
// import { styled } from '@mui/material/styles';
import products from '../Data/products.json';
import RightArrowIcon from '../assets/icons/rightArrow';
import Footer from '../components/Footer';
import DownArrowIcon from '../assets/icons/downArrow';
// import CloseIcon from '../assets/icons/closeIcon';
// import ArrowRightIcon from '../assets/icons/arrow-right';
// import PaginationItem from '@mui/material/PaginationItem';
// import ArrowLeftIcon from '../assets/icons/arrow-left';
import DashedBorder from '../assets/icons/border';
import images from '../assets/images';
import { useNavigate } from 'react-router-dom';
import Downloadbroch from '../components/Downloadbroch';

const Product = () => {
	const [isMdUp, setIsMdUp] = useState(window.innerWidth >= 768);
	const [selectedOption, setSelectedOption] = useState('All');
	const [open, setOpen] = useState(false);
	const options = [
		'All',
		'Retail & Shopping',
		'Agriculture',
		'Pharmaceutical',
	];
	// const [selectedSort, setSelectedSort] = useState('Name (A to Z)');
	const [openSort, setOpenSort] = useState(false);
	const sortRef = useRef(null);
	const optionRef = useRef(null);
	// const sortOptions = ['Name (A to Z)', 'Name (Z to A)', 'Date'];
	// const [page, setPage] = useState(1);
	// const itemsPerPage = 9;
	const [itemsPerPage, setItemsPerPage] = useState(16);
	// const startIndex = (page - 1) * itemsPerPage;
	// const endIndex = startIndex + itemsPerPage;
	// const visibleProducts = products.slice(startIndex, endIndex);
	const [visibleProducts, setVisibleProducts] = useState(products);
	// const [selectedProduct, setSelectedProduct] = useState(null);
	// const [isModalOpen, setIsModalOpen] = useState(false);
	const [radius, setRadius] = useState(24);
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const iconSize = isSmallScreen ? 20 : 24;
	const navigate = useNavigate();

	useEffect(() => {
		if (selectedOption === 'All') {
			setVisibleProducts(products);
		} else {
			const filtered = products.filter(
				(p) => p.category === selectedOption,
			);
			setVisibleProducts(filtered);
		}
	}, [selectedOption]);

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 768) {
				setRadius(24);
			} else {
				setRadius(16);
			}
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 640);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// const CustomPagination = styled(Pagination)(({ theme }) => ({
	// 	'& .MuiPagination-ul': {
	// 		display: 'flex',
	// 		justifyContent: 'center',
	// 		alignItems: 'center',
	// 		gap: '12px',
	// 		'@media (max-width:768px)': {
	// 			gap: '8px',
	// 		},
	// 	},

	// 	'& .MuiPaginationItem-root': {
	// 		width: '52px',
	// 		height: '52px',
	// 		borderRadius: '50%',
	// 		border: '1px solid #000',
	// 		fontFamily: 'Plus Jakarta Sans, sans-serif',
	// 		fontWeight: 500,
	// 		color: '#000',
	// 		backgroundColor: '#fff',
	// 		transition: 'all 0.3s ease',
	// 		'@media (max-width:768px)': {
	// 			width: '40px',
	// 			height: '40px',
	// 		},
	// 	},

	// 	'& .MuiPaginationItem-root.Mui-selected': {
	// 		backgroundColor: '#000',
	// 		color: '#fff',
	// 		border: '1px solid #000',
	// 	},
	// 	'& .MuiPaginationItem-root.Mui-selected:hover': {
	// 		backgroundColor: '#000',
	// 		color: '#fff',
	// 		border: '1px solid #000',
	// 	},

	// 	'& .MuiPaginationItem-root:hover': {
	// 		backgroundColor: '#000',
	// 		color: '#fff',
	// 		svg: {
	// 			stroke: '#fff',
	// 		},
	// 	},

	// 	'& .MuiPaginationItem-ellipsis': {
	// 		border: 'none',
	// 		background: 'none',
	// 		color: '#000',
	// 		fontSize: '20px',
	// 		// width: 'auto',
	// 		width: '52px',
	// 		height: '52px',
	// 		paddingTop: '10px',
	// 	},
	// 	'& .MuiPaginationItem-ellipsis:hover': {
	// 		border: 'none',
	// 		background: 'none',
	// 		color: '#000',
	// 		fontSize: '20px',
	// 		width: 'auto',
	// 	},

	// 	'& .MuiPaginationItem-previousNext': {
	// 		backgroundColor: '#000',
	// 		border: '1px solid #E5E5E5',
	// 		color: '#fff',
	// 		display: 'flex',
	// 		alignItems: 'center',
	// 		justifyContent: 'center',
	// 		svg: {
	// 			stroke: '#fff',
	// 			transition: 'stroke 0.3s ease',
	// 		},
	// 	},

	// 	'& .MuiPaginationItem-previousNext.Mui-disabled': {
	// 		backgroundColor: '#F8F8F8',
	// 		border: '1px solid #b8b4b4ff',
	// 		color: '#b8b4b4ff',
	// 		svg: {
	// 			stroke: '#b8b4b4ff',
	// 		},
	// 	},
	// }));

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			if (width >= 1280) setItemsPerPage(16);
			else if (width >= 1024) setItemsPerPage(16);
			else if (width >= 768) setItemsPerPage(16);
			else setItemsPerPage(16);
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const handleResize = () => setIsMdUp(window.innerWidth >= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (sortRef.current && !sortRef.current.contains(e.target)) {
				setOpenSort(false);
			}
			if (optionRef.current && !optionRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);
	return (
		<div className="w-full">
			{/* <div className="relative overflow-hidden">
				<div
					className="relative flex justify-center items-center xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `
							linear-gradient(225.42deg, #000000 19.01%, rgba(0, 0, 0, 0) 28.12%, rgba(0, 0, 0, 0) 36.49%, rgba(0, 0, 0, 0.80) 47.51%, #000000 81.02%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${heroImage})
							`
												: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${heroImage})
							`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<Navbar />
					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] lg:px-0 md:px-0 sm:px-0 ms:px-[20px] xs:px-[20px] flex flex-col justify-center">
						<h1 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[90px] sm:pt-[90px] md:pt-0 lg:pt-0 xl:pt-0">
							Products
						</h1>
						<p className="w-[252px] sm:w-[252px] md:w-[300px] lg:w-[405px] xl:w-[405px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							High-quality, sustainable products crafted to meet
							global standards.
						</p>
					</span>
				</div>
			</div> */}
			<div className="relative overflow-hidden">
				<div
					className="relative flex justify-center items-center h-[689px] xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `url(${heroImage})`
							: `url(${heroImage})`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<div
						className="absolute inset-0 pointer-events-none "
						style={{
							 opacity: isSmallScreen ? "0.8" : "1",
							background: isSmallScreen
								? `
							linear-gradient(225.42deg, rgb(0, 0, 0) 1.01%, rgba(0, 0, 0, 0) 5.12%, rgba(0, 0, 0, 0) 21.49%, rgba(0, 0, 0, 0.76) 51.51%, rgb(0, 0, 0) 76.02%), linear-gradient(rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 19.91%, rgba(0, 0, 0, 0) 100%)
							`
				
													: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%)
							`
						}}
					></div>

					<Navbar />

					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] lg:px-0 md:px-0 sm:px-0 ms:px-[20px] xs:px-[20px] flex flex-col justify-center">
						<h1 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[90px] sm:pt-[90px] md:pt-0 lg:pt-0 xl:pt-0">
							Products
						</h1>
						<p className="w-[252px] sm:w-[252px] md:w-[300px] lg:w-[405px] xl:w-[405px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							High-quality, sustainable products crafted to meet
							global standards.
						</p>
					</span>
				</div>
			</div>
			<div
				className={`relative flex flex-col items-center h-fit w-full bg-[#F7F7F5] pb-10`}
			>
				<div className="flex flex-col xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[425px] ms:w-full xs:w-full xl:pt-[140px] lg:pt-[140px] md:pt-[140px] sm:pt-[60px] pt-[60px] items-center px-[20px]">
					<div className="flex flex-col lg:flex-row justify-between items-center w-full md:gap-4 lg:gap-0 xl:gap-0 sm:gap-[24px] gap-[24px]">
						<h1 className="text-goudy xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold xl:text-[52px] lg:text-[52px] md:text-[50px] sm:text-[28px] text-[28px] leading-[120%] text-black">
							Products
						</h1>

						<div className="flex flex-col lg:flex-row lg:justify-end items-center gap-[16px] w-full">
							<div
								className="relative xl:w-[280px] lg:w-[280px] md:w-full w-full h-[54px]"
								ref={optionRef}
							>
								<div
									onClick={() => setOpen(!open)}
									className="appearance-none w-full h-full flex justify-between items-center 
									border border-[#C4BAA3] rounded-[18px] pt-[10px] xl:pr-[40px] lg:pr-[40px] md:pr-[40px] sm:pr-[24px] pr-[24px] pb-[14px] xl:pl-[20px] lg:pl-[20px] md:pl-[20px] sm:pl-[18px] pl-[18px]
									bg-[#FFFFFF66] shadow-[0_4px_20px_0_#0000000A] cursor-pointer font-plusJakarta
									font-normal xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px] leading-[100%] text-[#000000]"
								>
									<div className="flex gap-1">
										<span className="text-black/60">
											Use Case:
										</span>
										<span className="text-black/100 font-plusJakarta ">
											{selectedOption}
										</span>
									</div>

									<span className="absolute right-[18px] top-1/2 -translate-y-1/2 pointer-events-none text-[#000000] text-[14px]">
										<DownArrow />
									</span>
								</div>

								{open && (
									<div className="absolute top-[60px] left-0 w-full bg-white rounded-[18px] border border-[#C4BAA3] shadow-[0_4px_20px_0_#0000000A] z-10">
										{options.map((option) => (
											<div
												key={option}
												onClick={() => {
													setSelectedOption(option);
													setOpen(false);
												}}
												className="flex gap-2 items-center px-5 py-3 cursor-pointer hover:bg-gray-100 font-plusJakarta text-[16px]"
											>
												<span className="text-black/100">
													{option}
												</span>
											</div>
										))}
									</div>
								)}
							</div>
							{/* <div
								ref={sortRef}
								className="relative xl:w-[280px] lg:w-[280px] md:w-full w-full h-[54px]"
							>
								<div
									onClick={() => setOpenSort(!openSort)}
									className="appearance-none w-full h-full flex justify-between items-center 
									border border-[#C4BAA3] rounded-[18px] pt-[10px] pr-[40px] pb-[14px] pl-[20px] 
									bg-[#FFFFFF66] shadow-[0_4px_20px_0_#0000000A] cursor-pointer font-plusJakarta 
									font-normal xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px]  leading-[100%] text-[#000000]"
								>
									<div className="flex gap-1">
										<span className="text-black/60">
											Sort by:
										</span>
										<span className="text-black/100">
											{selectedSort}
										</span>
									</div>

									<span className="absolute right-[18px] top-1/2 -translate-y-1/2 pointer-events-none text-[#000000] text-[14px]">
										<DownArrow />
									</span>
								</div>
								{openSort && (
									<div className="absolute top-[60px] left-0 w-full bg-white rounded-[18px] border border-[#C4BAA3] shadow-[0_4px_20px_0_#0000000A] z-10">
										{sortOptions.map((option) => (
											<div
												key={option}
												onClick={() => {
													setSelectedSort(option);
													setOpenSort(false);
												}}
												className="flex gap-2 items-center px-5 py-3 cursor-pointer hover:bg-gray-100 font-plusJakarta text-[16px]"
											>
												<span className="text-black/60">
													Sort by:
												</span>
												<span className="text-black/100">
													{option}
												</span>
											</div>
										))}
									</div>
								)}
							</div> */}
						</div>
					</div>

					<div className="flex flex-col items-center justify-center xl:w-[1200px] lg:w-[800px] md:w-[400px] sm:w-auto ms:w-auto xs:w-auto pt-[40px]">
						<div className="grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 gap-[20px] w-full">
							{visibleProducts.map((p, idx) => (
								<div
									key={idx}
									className="xl:w-[387px] lg:w-[387px] md:w-[387px] sm:w-[261px] w-[261px] xl:h-[438px] lg:h-[438px] md:h-[438px] sm:h-[323px] h-[323px] bg-white rounded-[24px] shadow-[0px_4px_20px_0px_#0000000F] opacity-100 sm:px-[8px] px-[8px] md:px-[16px] lg:px-[16px] xl:px-[16px] pt-[8px] sm:pt-[8px] md:pt-[16px] lg:pt-[16px] xl:pt-[16px] relative"
								>
									<DashedBorder
										radiusDesktop={24}
										radiusMobile={24}
										color={p.color}
									/>
									<div className="xl:h-[241px] lg:h-[241px] md:h-[200px] sm:h-[166px] h-[166px] xl:w-[355px] lg:w-[355px] md:w-[355px] sm:w-[245px] w-[245px] rounded-[12px] flex items-center justify-center overflow-hidden">
										<img src={images[p.image]} alt='product'/>
									</div>
									<h3 className="pt-[14px] sm:pt-[14px] md:pt-[20px] lg:pt-[20px] xl:pt-[20px] xl:text-[20px] lg:text-[20px] md:text-[16px] sm:text-[16px] text-[16px] leading-[100%] font-[700] font-plusJakarta text-black xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px]">
										{p.name}
									</h3>
									<p className="h-fit pt-[10px] sm:pt-[10px] md:pt-[12px] lg:pt-[12px] xl:pt-[12px] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px] leading-[150%] font-[400] font-plusJakarta text-[#1D1D1D] xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px] h-[50px] line-clamp-2 overflow-hidden">
										{p.description ||
											'Ideal for supermarkets, clothing stores, and FMCG packaging.'}
									</p>
									<span
										className="w-fit font-plusJakarta mt-[16px] xl:px-[8px] lg:px-[8px] md:px-[8px] sm:px-[10px] px-[10px] font-[500] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px] leading-[100%] tracking-[0] text-black underline decoration-solid decoration-[1px] underline-offset-[4px] cursor-pointer flex items-center gap-2"
										onClick={() => navigate('/contact')}
									>
										Get Quote
										<span>
											<RightArrowIcon
												color="black"
												width={iconSize}
												height={iconSize}
											/>
										</span>
									</span>
									{/* <div className="flex justify-between items-center w-full pt-[16px] sm:pt-[16px] md:pt-[24px] lg:pt-[24px] xl:pt-[24px]">
										<div className="flex w-[80px] h-[14px] gap-1 items-center">
											<div className="relative w-[20px] h-[20px] flex items-center justify-center">
												<div className="w-[20px] h-[20px] border border-black rounded-full absolute"></div>
												<div className="w-[12px] h-[12px] bg-black rounded-full z-10"></div>
											</div>

											<div className="w-[12px] h-[12px] bg-black rounded-full"></div>
											<div className="w-[12px] h-[12px] bg-black rounded-full"></div>
											<div className="w-[12px] h-[12px] bg-black rounded-full"></div>
										</div>

										<div
											className="flex w-[120px] h-[24px] gap-[10px] items-center justify-end cursor-pointer"
											onClick={() => {
												setSelectedProduct(p);
												setIsModalOpen(true);
											}}
										>
											<span
												className="text-black font-medium xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[15px] text-[15px] leading-[100%] underline font-plusJakarta"
												style={{
													textDecorationStyle:
														'solid',
													textDecorationOffset: '0px',
													textDecorationThickness:
														'0px',
													textDecorationSkipInk:
														'auto',
												}}
											>
												Know More
											</span>
											<RightArrowIcon color="black" />
										</div>
									</div> */}
								</div>
							))}
						</div>
						{/* <div className="mt-[32px] sm:mt-[32px] md:mt-[64px] lg:mt-[64px] xl:mt-[64px] xl:w-[1200px] lg:w-[900px] md:w-[700px] sm:w-[393px] w-[393px]">
							<CustomPagination
								count={Math.ceil(
									products.length / itemsPerPage,
								)}
								page={page}
								onChange={(e, value) => setPage(value)}
								siblingCount={0}
								boundaryCount={1}
								renderItem={(item) => (
									<PaginationItem
										slots={{
											previous: () => <ArrowLeftIcon />,
											next: () => <ArrowRightIcon />,
										}}
										{...item}
									/>
								)}
							/>
						</div> */}
					</div>
				</div>
			</div>
			<Downloadbroch/>
			{/* {isModalOpen && selectedProduct && (
				<div className="fixed inset-0 bg-black/60 flex xl:flex-row lg:flex-row md:flex-row sm:flex-col flex-col xl:gap-0 lg:gap-0 md:gap-0 sm:gap-2 gap-3 justify-end xl:justify-center lg:justify-center md:justify-center sm:justify-center items-center z-50">
					<button
						className="relative w-[60px] h-[60px] p-[10px] 
							bg-white rounded-[32px] items-center justify-center 
							text-black text-xl font-bold cursor-pointer z-[60] md:hidden flex"
						style={{
							boxShadow: '0px 4px 20px 0px #0000003D',
						}}
						onClick={() => setIsModalOpen(false)}
					>
						<DashedBorder />
						<CloseIcon />
					</button>
					<div
						className="bg-white rounded-tl-[16px] rounded-tr-[16px] sm:rounded-[24px] relative flex flex-col md:flex-row xl:w-[846px] lg:w-[864px] md:w-[700px] xl:h-[416px] lg:h-[416px] md:h-[416px] sm:h-[500px] h-[500px]
                        xl:p-3 lg:p-3 md:p-3 sm:p-1 p-1"
						style={{
							position: 'relative',
							boxShadow: '0px 4px 20px 0px #0000000F',
						}}
					>
						<DashedBorder
							radiusDesktop={radius}
							radiusMobile={radius}
							topOnly={window.innerWidth <= 768}
						/>
						<button
							className="absolute -top-5 -right-5 w-[60px] h-[60px] p-[10px] 
							bg-white rounded-[32px] items-center justify-center 
							text-black text-xl font-bold cursor-pointer z-[60] hidden md:flex"
							style={{
								boxShadow: '0px 4px 20px 0px #0000003D',
							}}
							onClick={() => setIsModalOpen(false)}
						>
							<DashedBorder />
							<CloseIcon />
						</button>

						<div className="flex justify-center items-center relative">
							<img
								src={productModal}
								alt={selectedProduct.name}
								className="w-[450px] xl:h-[392px] lg:h-[392px] md:h-[392px] sm:h-[250px] h-[250px] rounded-[12px] sm:rounded-[24px] shadow-[0_4px_20px_0_#0000000F] object-cover opacity-100"
							/>
							<DashedBorder
								radiusDesktop={24}
								radiusMobile={12}
							/>
						</div>

						<div className="flex flex-col justify-between py-6 xl:px-6 lg:px-6 md:px-6 sm:px-3 px-3 h-full">
							<div className="gap-3 flex flex-col">
								<h2 className="text-[#000000] font-bold xl:text-[22px] lg:text-[22px] md:text-[22px] sm:text-[20px] text-[20px] leading-[100%] tracking-[0] font-['Goudy_Old_Style']">
									{selectedProduct.name}
								</h2>
								<p className="text-black font-[400] xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[14px] leading-[24px] tracking-[0] font-['Plus_Jakarta_Sans']">
									{selectedProduct.description ||
										'Ideal for supermarkets, clothing stores, and FMCG packaging.'}
								</p>

								<div className="flex w-[80px] h-[14px] gap-[8px] items-center pt-4">
									<div className="relative flex items-center justify-center">
										<div className="w-[22px] h-[22px] border border-black rounded-[11px] absolute"></div>
										<div className="w-[14px] h-[14px] bg-black rounded-[7px] z-10"></div>
									</div>

									<div className="w-[14px] h-[14px] bg-black rounded-[7px]"></div>
									<div className="w-[14px] h-[14px] bg-black rounded-[7px]"></div>
									<div className="w-[14px] h-[14px] bg-black rounded-[7px]"></div>
								</div>
							</div>

							<span className="font-['Plus_Jakarta_Sans'] font-medium xl:text-[16px] lg:text-[16px] md:text-[15px] sm:text-[15px] text-[15px] leading-[100%] tracking-[0] text-black underline decoration-solid decoration-[1px] underline-offset-[4px] cursor-pointer flex items-center gap-2">
								Get Quote
								<span>
									<RightArrowIcon color="black" />
								</span>
							</span>
						</div>
					</div>
				</div>
			)} */}

			<Footer />
		</div>
	);
};
export default Product;
